import React from 'react';
import '../less/credits_new.less';
import { Link, Button } from 'MWC';
import BusinessOrder from '../../BusinessOrder';
import Banner from "../../../auxiliary-components/shared/Banner";
import credits from "../../Credit/img/credits.png";
import credits_data from "../credits_list.json";
import archive_data from "../archive_credits_list.json";
import CreditsItem from "../components/credits-list/views/credits_list.c";



export default function template() {
    const lang = this.props.lang,
        isMobile = this.isViewportMobile(),
        page = 'credits',
        entity = 'private',
        modal = this.state.showModal ?
            <BusinessOrder entity={entity} attribute={this.state.showModal} closeModal={this.closeModal} /> :
            null;

    return (
        <div className="module-credit-list">
          <div className="banner-wrapper">
            <Banner
              img={credits}
              text={'CREDITS_TEXT'}
              textMob={'CREDITS_TEXT'}
              title={'CREDITS_TITLE'}
              toggleModal={null}
              page={page}
              isMobile={isMobile}>
            </Banner>
            <div className="btn-wrapper">
              <div className="btn-wrapper-item">
                <Link>
                  <Button className="btn-success"
                          onClick={() => this.showModal('become_client')}>
                    {this.l10n('BECOME_A_CLIENT')}
                  </Button>
                </Link>
              </div>
            </div>
          </div>
          <div className='credits-all'>
              <div className='credits-list actual'>
                  <CreditsItem isMobile={isMobile} page={page} data={credits_data} className="credits-list"></CreditsItem>
              </div>
              <div className='credits-list archive'>
                  <CreditsItem isMobile={isMobile} page={page} data={archive_data} className="credits-list"></CreditsItem>
              </div>
          </div>
          {modal}
        </div>
    );
}
